import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { contentHeaders, apiBaseUrl } from "../common/config/config";
import { ActionSheetController, Platform, LoadingController, ToastController } from "@ionic/angular";
let apiUrl = apiBaseUrl + "insurance_companies/";
@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  public allCompanies: any;
  public companyBranch: any;
  public process = null;
  public claimForm = null;
  public appKey = null;
  public mobile = null;
  public headers = new HttpHeaders();
  public faqs = null;
  public terms = null;
  public faqData: any;
  constructor(public http: HttpClient) {

  }
  getAll() {
    console.log("In getAll function", apiUrl, this.headers);
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl, { headers: this.headers }).subscribe((res) => {
        this.allCompanies = res['data'];
        resolve(this.allCompanies);
      },(err) => {
        reject(err);
      });
    });
  }

  getByUrl(url) {
    console.log("In getByUrl function", url, this.headers);
    return new Promise((resolve, reject) => {
      this.http.get(apiBaseUrl + url, { headers: this.headers }).subscribe((res) => {
        this.allCompanies = res['data'];
        resolve(this.allCompanies);
      },(err) => {
        reject(err);
      });
    });
  }

  getInsuranceCompanyBranches(companyId) {
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl + companyId + "/branches", { headers: this.headers }).subscribe((res) => {
        this.companyBranch = res['data'];
        resolve(this.companyBranch);
      },(err) => {
        reject(err);
      });
    });
  }

  setHeaders() {
    this.mobile += "";
    if (this.mobile.length <= 10) this.mobile = "91" + this.mobile;
    if (!this.headers.has("mobile")) this.headers.append("mobile", this.mobile);
    if (!this.headers.has("app-key")) this.headers.append("app-key", this.appKey);
    if (!this.headers.has("Access-Control-Allow-Origin")) this.headers.append("Access-Control-Allow-Origin", "*");
  }

  createFaqs(data, appType) {
    return new Promise((resolve, reject) => {
      this.http.post(apiBaseUrl + "query", data, { headers: this.headers }).subscribe((res) => {
        this.faqData = res['data'];
        resolve(res);
      },(err) => {
        console.log("response", JSON.stringify(err));
        reject(err);
      });
    });
  }
}
